import { motion } from 'motion/react';
import { ChevronRight, GitCompareArrows } from 'lucide-react';

type StockAnalogueTeaserCardProps = {
  onClick: () => void;
};

export function StockAnalogueTeaserCard({ onClick }: StockAnalogueTeaserCardProps) {
  return (
    <motion.button
      type="button"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.15 }}
      onClick={onClick}
      className="group w-full cursor-pointer rounded-2xl border border-gray-200 bg-white p-6 text-left transition-all duration-300 hover:border-gray-900"
    >
      <div className="flex items-center justify-between gap-6">
        <div className="min-w-0">
          <div className="mb-2 flex items-center gap-2">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gray-900">
              <GitCompareArrows className="h-4 w-4 text-white" />
            </div>
            <span className="text-xs font-semibold uppercase tracking-wider text-gray-400">
              Analogue Analysis
            </span>
          </div>
          <h4 className="text-gray-900 transition-transform group-hover:translate-x-1">
            Wednesday, July 1, 2026 — Here&apos;s what happened today
          </h4>
          <p className="mt-1 text-sm text-gray-500">
            Why it moved · Historical analogues · Risks to monitor
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            <span className="rounded-lg bg-emerald-50 px-3 py-1 text-sm text-emerald-800">+9.21%</span>
            <span className="rounded-lg bg-gray-100 px-3 py-1 text-sm text-gray-600">3 analogues</span>
            <span className="rounded-lg bg-amber-50 px-3 py-1 text-sm text-amber-800">July 2 NFP risk</span>
          </div>
        </div>
        <ChevronRight className="h-5 w-5 shrink-0 text-gray-400 transition-all group-hover:translate-x-1 group-hover:text-gray-900" />
      </div>
    </motion.button>
  );
}
